// react
import React from "react";

// helpers
import {createMarkup} from "../../../helpers/renderHelpers.js";

// styling
import "./Loading.scss";

const Loading = (props) => {
  const {message} = props;
  return (
    <div className="hero-loading">
        {message ? (
            <span style={{fontSize: '40px', color: '#D90000'}}>&#9888;</span>
        ): (
            <div className="hero-loading-spin"></div>
        )}
        <p dangerouslySetInnerHTML = {createMarkup(message || "Please wait...")} />
    </div>
    );
};

export default Loading;
